import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    width: theme.spacing(34),
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      width: 'auto',
      backgroundColor: 'transparent',
    },
  },

  logoContainer: {
    width: theme.spacing(18.5),
  },

  logo: {
    width: '100%',
    height: theme.spacing(4),
    objectFit: 'contain',
  },
}));
